/* eslint-disable */
import VersionNumber from 'react-native-version-number'

export const devConfig = {
  appDetails: {
    buildNumber: VersionNumber.buildVersion,
    bundleDisplayName: "KrgoVNdevF",
    userAgent : 'web React Kargoe',
    appVersion: VersionNumber.appVersion + '.' + VersionNumber.buildVersion,
    bundleId: "com.kargoe.krgovndev",
    urlScheme: "krgovndev",
    onScreenIdentifier: {
      label: 'dev ' + VersionNumber.appVersion + '.' + VersionNumber.buildVersion,
      color: 'black',
      bgColor: 'teal'
    },
  },
  inAppPurchases: {
    productIds: [
      // 'com.example.coins100'
      'kartoken100',
      'com.kargoe.krgovndev.kartoken500',
      'kartoken2000',
      'kartoken3700',
      'kartoken16500',
    ]    
  },

  BASE_URL_MEDIA: "https://s3.amazonaws.com/kargoe2-dev",
  BASE_URL_API: "https://dev-api.kargoe.com/webapi/",
  BASE_URL_ADMIN: "https://dev-admin.kargoe.com/",

  GOOGLE_GEOCODING_KEY: "AIzaSyAnYGK8WNE0AxOA5OdnkXBGiJPVJSjnP68", // these are Kargoe API keys
  GOOGLE_API_KEY: "AIzaSyBFrAWG1K6_ZYPsi6yLYx3hrGUhZb40joA",

  SHOPPABLE_API_URL: "https://api.shoppable.co/",
  
  ONE_SIGNAL_KEY: "887dcd45-c0f2-493f-9f2b-a4e53765c518", // krgovndev
/*
note, this value will change based upon the app bundle id see onesignal.com console
krgovndevcam:  "6337d531-fede-4ba9-870f-60b93ffad772"
krgovndev:     "887dcd45-c0f2-493f-9f2b-a4e53765c518"
kargoe:        "1f976ec9-db65-45e6-a842-3684ec1a4fda"
*/
}
